import { useState } from "react";
import { db } from "../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";

function EditTournament() {
  const navigate = useNavigate();
  const location = useLocation();

  // 🔥 data from route
  const { id, data, collectionName } = location.state || {};

  const [form, setForm] = useState({
    title: data?.title || "",
    map: data?.map || "",
    mode: data?.mode || "",
    entryFee: data?.entryFee || 0,
    perKill: data?.perKill || 0,
    prizePool: data?.prizePool || 0,
    time: data?.time?.seconds
      ? new Date(data.time.seconds * 1000)
          .toISOString()
          .slice(0, 16)
      : "",
  });

  const [loading, setLoading] = useState(false);

  const handle = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 🔥 UPDATE
  const updateTournament = async () => {
    if (!form.title || !form.time) {
      alert("Fill all fields");
      return;
    }

    setLoading(true);

    try {
      await updateDoc(doc(db, collectionName, id), {
        title: form.title,
        map: form.map,
        mode: form.mode,
        entryFee: Number(form.entryFee),
        perKill: Number(form.perKill),
        prizePool: Number(form.prizePool),
        time: new Date(form.time),
      });

      alert("Updated ✅");
      navigate(-1);
    } catch (e) {
      alert("Error: " + e.message);
    }

    setLoading(false);
  };

  return (
    <div style={container}>
      <div style={card}>
        <h1 style={title}>✏️ Edit Tournament</h1>

        <Input label="Title" name="title" value={form.title} onChange={handle} />
        <Input label="Map" name="map" value={form.map} onChange={handle} />
        <Input label="Mode" name="mode" value={form.mode} onChange={handle} />

        <Input
          label="Entry Fee"
          name="entryFee"
          type="number"
          value={form.entryFee}
          onChange={handle}
        />

        <Input
          label="Per Kill"
          name="perKill"
          type="number"
          value={form.perKill}
          onChange={handle}
        />

        <Input
          label="Prize Pool"
          name="prizePool"
          type="number"
          value={form.prizePool}
          onChange={handle}
        />

        <Input
          label="Match Time"
          name="time"
          type="datetime-local"
          value={form.time}
          onChange={handle}
        />

        <button style={btn} onClick={updateTournament}>
          {loading ? "Updating..." : "Update Tournament"}
        </button>
      </div>
    </div>
  );
}

/* 🔥 INPUT COMPONENT */

function Input({ label, ...props }) {
  return (
    <div style={inputGroup}>
      <label style={labelStyle}>{label}</label>
      <input {...props} style={input} />
    </div>
  );
}

/* 🔥 STYLES */

const container = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
};

const card = {
  background: "#1E2235",
  padding: 25,
  borderRadius: 12,
  width: 360,
  display: "flex",
  flexDirection: "column",
  gap: 12,
  boxShadow: "0 0 20px rgba(0,0,0,0.4)",
};

const title = {
  color: "#fff",
  textAlign: "center",
  marginBottom: 10,
};

const inputGroup = {
  display: "flex",
  flexDirection: "column",
  gap: 4,
};

const labelStyle = {
  fontSize: 13,
  color: "#9CA3AF",
};

const input = {
  padding: 10,
  borderRadius: 8,
  border: "1px solid #2A2F45",
  background: "#0F1221",
  color: "#fff",
  outline: "none",
};

const btn = {
  marginTop: 10,
  padding: 12,
  borderRadius: 10,
  border: "none",
  background: "linear-gradient(135deg, #2563EB, #1D4ED8)",
  color: "#fff",
  cursor: "pointer",
  fontWeight: "bold",
};

export default EditTournament;